import { Injectable } from '@angular/core';
import { Pageable } from '@nimmsta/ng-commons-lib/models';
import { SFSOptions } from '@nimmsta/ng-commons-lib/data-access';
import { map, Observable } from 'rxjs';
import { LightTag } from '../models/lighttag';
import { LightTagService } from './lighttag.service';

@Injectable({
  providedIn: 'root',
})
export class LightTagAdminService extends LightTagService {
  override list(options: Partial<SFSOptions> = {}): Observable<Pageable<LightTag>> {
    const params = this.getParams(options);
    return this.http.get<Pageable<LightTag>>(`${this.baseUrl + this.apiEndpoint}/all`, {
      params,
    }).pipe(map((page) => {
      page.content = page.content.map((item) => this.loadedDataTransform(item));
      return page;
    }));
  }
}
